module.exports = __webpack_public_path__ + "img/shift-change.d74ef086.svg";